import { render, staticRenderFns } from "./meal_result.vue?vue&type=template&id=524562f5&"
import script from "./meal_result.vue?vue&type=script&lang=js&"
export * from "./meal_result.vue?vue&type=script&lang=js&"
import style0 from "./meal_result.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports